/**
 * FunnelCartBanner — slim green banner for the SideCart topBanner slot.
 *
 * Renders a small promotional banner (~20px tall) that visually signals
 * the funnel is active. Uses the funnel context to determine if a funnel
 * is assigned to the current session.
 */

import styled from '@emotion/styled';
import { useFunnelContext } from '@template-project/storefront-funnel';

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 12px;
  background: linear-gradient(90deg, #4caf50, #66bb6a);
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1;
  flex-shrink: 0;
`;

const Icon = styled.span`
  font-size: 12px;
`;

export function FunnelCartBanner() {
  const { assignedFunnelId } = useFunnelContext();

  if (!assignedFunnelId) return null;

  return (
    <Banner data-testid="funnel-cart-banner">
      <Icon>✦</Icon>
      Special offer applied to your cart
    </Banner>
  );
}
